import { formatDateFromTimestampAndAddMilliseconds } from "../../utils/helpers";
import { Button, useOpenClose } from "@evertrue/et-components";
import { resumePauseTitle, resumePauseBody, resumePauseAction } from "../../utils/constants/constants";
import ConfirmModal from "../modals/confirm-pause-modal";
import { trackJourneysAction } from "apps/journeys/utils/helpers";
import useJourneyTimeoutsApi from "apps/journeys/hooks/journey-timeouts/use-journey-timeouts-api";

const JourneyPauseContainer = () => {
  const { inProgressJourneyTimeout, handleResume } = useJourneyTimeoutsApi();
  const [isModalOpen, openModal, closeModal] = useOpenClose();

  const resumeAction = () => {
    trackJourneysAction("end_cadence_pause");
    handleResume();
    closeModal();
  };

  return (
    <>
      <div className="journeys-edit-pause--container">
        {inProgressJourneyTimeout && (
          <div className="journeys-edit-pause--container">
            <div className="journeys-edit-pause-main">
              <h1 className="bold-text journeys-paused-msg">{`Your cadences are paused until ${formatDateFromTimestampAndAddMilliseconds(
                inProgressJourneyTimeout.pause_end
              )}`}</h1>
              <p>We hope you are having a restful break! Tasks are still available but not due.</p>
              <div>
                <Button
                  type="secondary"
                  onClick={() => {
                    openModal();
                  }}
                >
                  Resume All Cadences
                </Button>
                <Button
                  href="settings/cadence"
                  onClick={() => {
                    console.log("test");
                    trackJourneysAction("edit_cadence_pause");
                  }}
                >
                  Edit Pause
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <ConfirmModal
        title={resumePauseTitle}
        body={resumePauseBody}
        handleAction={resumeAction}
        actionName={resumePauseAction}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
};

export default JourneyPauseContainer;
